var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.excelLoading
    },
    on: {
      "update:active": function($event) {
        _vm.excelLoading = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    attrs: {
      "id": "ltcform"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('b-form-fieldset', [_c('b-form-radio', {
    attrs: {
      "name": "searchview",
      "id": "searchview",
      "plain": true,
      "options": _vm.options
    },
    on: {
      "input": function($event) {
        _vm.changeRadio(_vm.selected)
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "opt"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0rem",
      "margin-bottom": "0rem"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Client Name/ Id")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.clientLoading
    },
    on: {
      "update:active": function($event) {
        _vm.clientLoading = $event
      }
    }
  }), _vm._v(" "), _c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6",
      "z-index": "999"
    },
    attrs: {
      "multiple": _vm.multipleC(),
      "options": _vm.ClientList,
      "name": "Client",
      "id": "Client",
      "placeholder": "Search Client Name/ Id",
      "label": "CompanyName",
      "track-by": "ClientId",
      "optionHeight": 100,
      "hide-selected": true
    },
    model: {
      value: (_vm.Client),
      callback: function($$v) {
        _vm.Client = $$v
      },
      expression: "Client"
    }
  }, [_c('template', {
    slot: "noResult"
  }, [_c('p', [_vm._v("No Record Found.")])])], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "clienterr"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected != 'Initiated'),
      expression: "selected!='Initiated'"
    }],
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Transaction Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true
    },
    staticStyle: {
      "height": "45px",
      "border-right-color": "transparent"
    },
    attrs: {
      "id": "fromDate",
      "type": "date",
      "name": "fromDate"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  }), _vm._v(" "), _c('b-form-input', {
    class: {
      'form-control': true
    },
    staticStyle: {
      "height": "45px",
      "border-left-color": "transparent"
    },
    attrs: {
      "id": "toDate",
      "type": "date",
      "name": "toDate"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "fdate"
    }
  })], 1), _vm._v(" "), (_vm.selected == 'Done') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Delivery Cycle")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.delvLoading
    },
    on: {
      "update:active": function($event) {
        _vm.delvLoading = $event
      }
    }
  }), _vm._v(" "), _c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6",
      "z-index": "999"
    },
    attrs: {
      "multiple": _vm.multipleD(),
      "options": _vm.DelvCycleList,
      "name": "delvcycle",
      "id": "delvcycle",
      "placeholder": "Search Delivery Cycle",
      "label": "cycle",
      "track-by": "fromDate",
      "optionHeight": 100,
      "hide-selected": true
    },
    model: {
      value: (_vm.delvcycle),
      callback: function($$v) {
        _vm.delvcycle = $$v
      },
      expression: "delvcycle"
    }
  }, [_c('template', {
    slot: "noResult"
  }, [_c('p', [_vm._v("No Record Found.")])])], 2)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.selected == 'Initiated' ? 'col-md-8' : _vm.selected == 'Hold' ? 'col-md-4' : 'col-md-12',
    staticStyle: {
      "margin-top": "3%"
    }
  }, [_c('span', [_vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    staticStyle: {
      "border-radius": "5px",
      "padding": "5px 12px"
    },
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Clear")])]), _vm._v(" "), _c('span', {
    style: (_vm.selected == 'Done' ? 'margin-left: 68%' : 'margin-left: 25%')
  }, [(_vm.selected == 'Initiated') ? _c('button', {
    staticClass: "btn btn-sm btn-ltc",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "title": "Download Remittance Report",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.exportData()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]) : _vm._e(), _vm._v(" "), (_vm.selected == 'Initiated') ? _c('label', {
    staticClass: "custom-file-upload btn-ltc",
    staticStyle: {
      "border-radius": "5px"
    },
    attrs: {
      "title": "Bulk Remittance",
      "for": "remittancefile"
    }
  }, [_vm._v("Bulk Upload "), _c('i', {
    staticClass: "fa fa-upload"
  })]) : _vm._e(), _c('input', {
    attrs: {
      "type": "file",
      "name": "remittancefile",
      "id": "remittancefile",
      "placeholder": "Bulk Remittance"
    },
    on: {
      "change": _vm.onUpload
    }
  }), _vm._v(" "), (_vm.selected == 'Initiated') ? _c('button', {
    staticClass: "btn btn-sm btn-ltc",
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "title": "Hold Client Remittance",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.bulkAction("Hold")
      }
    }
  }, [_vm._v("Hold")]) : _vm._e(), _vm._v(" "), (_vm.selected != 'Done') ? _c('button', {
    staticClass: "btn btn-sm btn-ltc",
    staticStyle: {
      "width": "85px"
    },
    attrs: {
      "title": "Approve Client Remittance",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.bulkAction("Done")
      }
    }
  }, [_vm._v("Approve")]) : _vm._e(), _vm._v(" "), (_vm.selected == 'Done' && _vm.resultCount > 0) ? _c('button', {
    staticClass: "btn btn-sm btn-ltc",
    attrs: {
      "title": "Download Remittance Report",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.exportData()
      }
    }
  }, [_vm._v("Remittance Report "), _c('i', {
    staticClass: "fa fa-download"
  })]) : _vm._e()])])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "ShipmentModalRef",
    attrs: {
      "id": "#confirmationmodal3",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.modalShipmentShow),
      callback: function($$v) {
        _vm.modalShipmentShow = $$v
      },
      expression: "modalShipmentShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.shipLoading
    },
    on: {
      "update:active": function($event) {
        _vm.shipLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-headerfrm"
  }, [(_vm.shipmentList.length > 0) ? _c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("Total COD Shipments (" + _vm._s(_vm.shipmentList.length) + ")")]) : _vm._e(), _vm._v(" "), (_vm.exceptionList.length > 0) ? _c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("Exception Shipments (" + _vm._s(_vm.exceptionList.length) + ")")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [(_vm.shipmentList.length > 0) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    class: ("" + ((_vm.shipmentList.length>10) ? ' scroll' : '')),
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "25px"
    }
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "298px"
    }
  }, [_c('b', [_vm._v("AWB Number")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "128px"
    }
  }, [_c('b', [_vm._v("COD Amount ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])])])]), _vm._v(" "), _c('tbody', [(_vm.shipmentList.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.shipmentList), function(val, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "70%"
      }
    }, [_vm._v(_vm._s(val.ShippingID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(val.NetPayment))])])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.exceptionList.length > 0) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    class: ("" + ((_vm.exceptionList.length>10) ? ' scroll' : '')),
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "25px"
    }
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "298px"
    }
  }, [_c('b', [_vm._v("AWB Number")])])])]), _vm._v(" "), _c('tbody', [(_vm.exceptionList.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.exceptionList), function(val, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "70%"
      }
    }, [_vm._v(_vm._s(val))])])
  })], 2)]) : _vm._e()])], 1)])]), _vm._v(" "), _c('b-modal', {
    ref: "myModalRef",
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.ModalShow),
      callback: function($$v) {
        _vm.ModalShow = $$v
      },
      expression: "ModalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.status == 'UTR' ? 'UTR Confirmation' : 'Remittance Approval'))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [(_vm.singleArr.length > 0 && _vm.status != 'UTR') ? _c('h5', {
    staticStyle: {
      "font-size": "1rem",
      "color": "red"
    }
  }, [_vm._v("Remittance for Client " + _vm._s(_vm.singleArr.length > 0 ? _vm.singleArr[0].ClientId : '') + " is Rs " + _vm._s(_vm.singleArr.length > 0 ? _vm.singleArr[0].RemittanceAmount : '') + ".")]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.ClientArr.length > 0 && _vm.status != 'UTR') ? _c('h5', {
    staticStyle: {
      "font-size": "1rem",
      "color": "red"
    }
  }, [_vm._v("Remittance for checked clients.")]) : _vm._e(), _c('br'), _vm._v(" "), _c('h5', {
    staticStyle: {
      "font-size": "1rem",
      "color": "red"
    }
  }, [_vm._v("Do you want to " + _vm._s(_vm.status == 'Done' ? 'approve it.' : _vm.status == 'UTR' ? 'add UTR number.' : 'hold it.'))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('center', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "background-color": "#20a8d8"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.hideModal('0')
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "background-color": "#f86c6b"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.hideModal('1')
      }
    }
  }, [_vm._v("No")])])], 1)])])]), _vm._v(" "), _c('b-modal', {
    ref: "myClosureModalRef",
    on: {
      "ok": function($event) {
        _vm.FCModal = false
      }
    },
    model: {
      value: (_vm.FCModal),
      callback: function($$v) {
        _vm.FCModal = $$v
      },
      expression: "FCModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('form', {
    attrs: {
      "id": "FCform"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onUpdate()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v(_vm._s(_vm.status == 'UTR' ? 'UTR Details' : 'Long Tail Remittance'))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('b-form-fieldset', [(_vm.status != 'UTR') ? _c('label', [_vm._v("Remark")]) : _vm._e(), _vm._v(" "), _c('b-input-group', [(_vm.status != 'UTR') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.holdremark),
      expression: "holdremark"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    ref: "textarea",
    class: {
      'form-control': true, 'error': _vm.errors.has('holdremark')
    },
    attrs: {
      "rows": "4",
      "name": "holdremark",
      "id": "holdremark",
      "placeholder": "Enter Hold Remark"
    },
    domProps: {
      "value": (_vm.holdremark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.holdremark = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.status == 'UTR') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.utrno),
      expression: "utrno"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('utrno')
    },
    attrs: {
      "type": "text",
      "id": "utrno",
      "name": "utrno",
      "placeholder": "Enter UTR Number"
    },
    domProps: {
      "value": (_vm.utrno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.utrno = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "utrHolderr"
    }
  }, [_vm._v(_vm._s(_vm.status == 'UTR' ? 'UTR number' : 'Hold Remark') + " is required. ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "rolefooter form-actions"
  }, [_c('b-button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Submit")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_vm._v("Cancel")])], 1)])])], 1)])])])])]), _vm._v(" "), _c('b-modal', {
    ref: "myCommentModalRef",
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.commentModalShow),
      callback: function($$v) {
        _vm.commentModalShow = $$v
      },
      expression: "commentModalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Reason/Remark")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "0.9rem",
      "color": "black"
    }
  }, [_vm._v(_vm._s(_vm.comment))])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.bulkResp.length == 0) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._m(2), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables scrolltb",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_vm._m(3), _vm._v(" "), (_vm.selected != 'Done') ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAll),
      expression: "checkAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkAll) ? _vm._i(_vm.checkAll, null) > -1 : (_vm.checkAll)
    },
    on: {
      "click": _vm.check,
      "__c": function($event) {
        var $$a = _vm.checkAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkAll = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checkAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkAll = $$c
        }
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), (_vm.selected != 'Done') ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._m(9)]) : _vm._e(), _vm._v(" "), (_vm.selected == 'Done') ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Approved On")])]) : _vm._e(), _vm._v(" "), (_vm.selected != 'Hold') ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._m(10)]) : _vm._e(), _vm._v(" "), (_vm.selected == 'Hold') ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._m(11)]) : _vm._e(), _vm._v(" "), (_vm.selected == 'Hold') ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Reason/Remark")])]) : _vm._e(), _vm._v(" "), (_vm.selected == 'Done') ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Remittance Id")])]) : _vm._e(), _vm._v(" "), (_vm.selected == 'Done') ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("UTR #")])]) : _vm._e(), _vm._v(" "), _vm._m(12)])]), _vm._v(" "), _c('tbody', [(_vm.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.selected == 'Initiated' ? 10 : 11,
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listPendingRemittanceData), function(data, index) {
    return (_vm.resultCount > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.pageno + index + 1))])]), _vm._v(" "), (_vm.selected != 'Done') ? _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ClientArr),
        expression: "ClientArr"
      }],
      attrs: {
        "type": "checkbox",
        "name": ("" + ("ClientId"+data.ClientId)),
        "id": ("" + ("ClientId"+data.ClientId))
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.ClientArr) ? _vm._i(_vm.ClientArr, data) > -1 : (_vm.ClientArr)
      },
      on: {
        "change": function($event) {
          _vm.updateCheck()
        },
        "__c": function($event) {
          var $$a = _vm.ClientArr,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.ClientArr = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.ClientArr = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ClientArr = $$c
          }
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ClientId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.CompanyName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.Cycle))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.CODAmount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ExceptionAmount) + " "), (data.ExceptionAWB.length > 0) ? _c('i', {
      staticClass: "fa fa-exclamation-circle",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.exShipments(data.ExceptionAWB)
        }
      }
    }) : _vm._e()]), _vm._v(" "), (_vm.selected != 'Done') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.WalletBalance))]) : _vm._e(), _vm._v(" "), (_vm.selected == 'Done') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.RemittanceDate))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.RemittanceAmount) + " "), _c('i', {
      staticClass: "fa fa-exclamation-circle",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.ltcRemitShipments(data.FromDate, data.ToDate, data.ClientId)
        }
      }
    })]), _vm._v(" "), (_vm.selected == 'Hold') ? _c('td', {
      staticClass: "text-center"
    }, [(data.Remark) ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "rgb(25,25,112)",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          _vm.showComment(data.Remark)
        }
      }
    }, [_vm._v("view")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selected == 'Done') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.RemittanceId))]) : _vm._e(), _vm._v(" "), (_vm.selected == 'Done') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.UTR))]) : _vm._e(), _vm._v(" "), (_vm.selected != 'Hold') ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "font-size": "x-large"
      }
    }, [_c('b', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.PopUp(data.RemittanceId)
        }
      }
    }, [_vm._v("...")]), _vm._v(" "), _c('b', [(_vm.selected == 'Initiated') ? _c('span', {
      staticClass: "popUpText",
      attrs: {
        "id": ("" + ("popUpText"+data.RemittanceId))
      }
    }, [_c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.action("Done", data)
        }
      }
    }, [_vm._v("Approve")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": "20px",
        "cursor": "pointer"
      },
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": _vm.closeStatusRoleModal
      }
    }, [_vm._v("×")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.action("Hold", data)
        }
      }
    }, [_vm._v("Hold")])]) : _vm._e(), _vm._v(" "), (_vm.selected == 'Done') ? _c('span', {
      staticClass: "popUpText",
      attrs: {
        "id": ("" + ("popUpText"+data.RemittanceId))
      }
    }, [_c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.action("UTR", data)
        }
      }
    }, [_vm._v("ADD UTR #")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": "8px",
        "cursor": "pointer"
      },
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": _vm.closeStatusRoleModal
      }
    }, [_vm._v("×")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.selected == 'Hold') ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "font-size": "x-large"
      }
    }, [_c('button', {
      staticClass: "btn btn-sm btn-ltc",
      staticStyle: {
        "width": "80px",
        "border-radius": "5px"
      },
      attrs: {
        "title": "Approve Client Remittance",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.action("Done", data)
        }
      }
    }, [_vm._v("Approve")])]) : _vm._e()]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isFirefox),
      expression: "!isFirefox"
    }],
    staticStyle: {
      "font-size": "12px",
      "color": "#d40000"
    }
  }, [_vm._v("Note: Multi checkbox is fully supported in Firefox browser, you can use Firefox to browse the site."), _c('br')]), _vm._v(" "), _c('br'), (_vm.resultCount > 0) ? _c('paginate', {
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '«',
      "next-text": '»',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.bulkResp && _vm.bulkResp.length > 0) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables scrolltb",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(13), _vm._v(" "), _c('tbody', _vm._l((_vm.bulkResp), function(data, index) {
    return _c('tr', [_vm._m(14, true), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.success))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.failed) + "  "), (data.s3link) ? _c('b-link', {
      attrs: {
        "href": ("" + (data.s3link))
      }
    }, [_vm._v("view")]) : _vm._e()], 1)])
  }))]), _c('br'), _vm._v(" "), _c('paginate', {
    attrs: {
      "page-count": 1,
      "page-range": 2,
      "margin-pages": 2,
      "prev-text": '«',
      "next-text": '»',
      "container-class": 'pagination'
    }
  })], 1)]) : _vm._e()])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    staticClass: " fa fa-filter filter"
  }), _vm._v(" Long Tail Remittance\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-sm btn-primary",
    staticStyle: {
      "border-radius": "5px",
      "padding": "5px 12px"
    },
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Result")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("#")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Client ID")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Client Name")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Delivery Cycle")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("COD Amount ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Exception Amount ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_vm._v("Wallet Balance ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_vm._v("Total Remittance ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_vm._v("Hold Value ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Action")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Success")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Failure")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center",
    attrs: {
      "scope": "row"
    }
  }, [_c('strong', [_vm._v("1")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57351932","hasScoped":true}!./src/views/components/longtailclient/longtailclient.component.html
// module id = 720
// module chunks = 1